var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"htmleditor"}},[_c('div',{staticClass:"m-2"},[_c('h4',{staticClass:"mb-3"},[_vm._v("Rikt innehåll")]),_c('p',[_vm._v("Editor")])])])
}]
render._withStripped = true
export { render, staticRenderFns }